export const CHART_AREA_Y1 = 205;
export const ZERO_POINT_Y1 = 25;
export const UNREALIZED_PROFIT_THOUSAND_HUNDRED_PERCENT = 100;
